import { ReactElement } from 'react';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

import { ITextareaProps, Textarea } from './Textarea';

type Value = ITextareaProps['value'];
type ITextareaFieldProps = ITextareaProps &
  FieldProps<Value, FieldRenderProps<Value>> & {
    fieldKey?: ReactElement['key'];
  };

export const TextareaField = (props: ITextareaFieldProps) => (
  <Field {...props}>
    {({ input, meta }) => {
      const error = (meta.touched && props.error) || (meta.touched && meta.error) ? meta.error : undefined;
      return <Textarea {...props} {...input} error={error} />;
    }}
  </Field>
);
